import React, { useState, useEffect } from 'react';


const Calcolo_tempo_visione = (props) => {


  const [vettorestate, funzione_vettore] = useState([0, 0, 0, 0, 0]);


  useEffect(() => {
    riempi_la_progress_bar()
  }, [props.tempo_corrente]);

  /*
      useEffect(() => {
        const interval = setInterval(() => 
        {riempi_la_progress_bar()}, 25000);
        return () => clearInterval(interval);
      }, []);
  */

  const riempi_la_progress_bar = () => {
    console.log(props.tempo_corrente)

    if (props.player_current === null) {

      console.log('Calcolo_tempo_visione player_current null')
      return
    }

    var utente_new = props.utente
    var indice = props.video_scelto.indice
    var size_vettore = utente_new.video_guardati[indice].array_visione.length - 1

    var vettore = utente_new.video_guardati[indice].array_visione
    var indice_punto_progress = Math.floor(size_vettore * props.tempo_corrente / props.tempo_durata_video)

/*    if (vettore[indice_punto_progress] == 0) {
      props.funzione_set_aggiornamento(true)
      vettore[indice_punto_progress] = 1
    }
*/    
    props.funzione_set_aggiornamento(true)
    vettore[indice_punto_progress] = vettore[indice_punto_progress] + 1

    console.log('calcolo_tempo_visione.js ' + vettore)

    utente_new.video_guardati[indice].array_visione = vettore
    funzione_vettore(vettore)
    
    props.funzione_set_lista_utenti(utente_new)
    //      props.funzione_vettore_progress(vettore)
  }
/*
 

*/

  return (
    <div class="out1">
      {/*  
      <button onClick={riempi_la_progress_bar}>Prendi la statistica</button>
      */}
      {0 > 0 && (
          <p>{JSON.stringify(props.utente)}</p>
      )}
    </div>
  )
}

export default Calcolo_tempo_visione;